import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * HttpClient utilisé pour charger la configuration des APIs
 * Tous les HttpInterceptors sont ignorés avec cet HttpClient
 */
@Injectable({
  providedIn: 'root',
})
export class ConfigurationHttpClient extends HttpClient {
  constructor(httpBackend: HttpBackend) {
    super(httpBackend);
  }
}
